<template lang="pug">
  v-container#details(fluid)
    h1.form-title2.accent-text.pb-5 Detalles
    v-row.py-1
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Existen testigos de la desaparición?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="witnessesExists" row hide-details  @change="clearDetails($event,'witness')")
              v-radio(
              	v-for="(witnessesExistsOpt, i) in directAnswers"
              	:key="`witnessesExistsOpt${i}`"
              	:value="i"
              	:label="witnessesExistsOpt.name"
                color="main-color"
               
              )
          v-col.side-label(d-flex flex xs=7 sm=8)
            label.custom-secondary.pr-3 Detalles
            v-text-field.pt-0(
              ref="witness"
              :disabled = "!!witnessesExists"
            	v-model="witnessesDetails"
              hide-details
            )
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿La desaparición fue a bordo de un vehículo?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="disappearInVehicle" row hide-details @change="clearDetails($event,'disappear-vehicle')")
              v-radio(
              	v-for="(disappearInVehicleOpt, i) in directAnswers"
              	:key="`disappearInVehicleOpt${i}`"
              	:value="i"
              	:label="disappearInVehicleOpt.name"
                color="main-color"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Detalles
            v-text-field.pt-0(
              ref="disappear-vehicle"
              :disabled = "!!disappearInVehicle"
            	v-model="disappearVehicletDetails"
              hide-details
            )

    v-row.py-9
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Hubo algún incidente después de la desaparición?
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="postIncidents" row hide-details @change="clearDetails($event,'postincident')")
              v-radio(
              	v-for="(postIncidentsOpt, i) in directAnswers"
              	:key="`postIncidentsOpt${i}`"
              	:value="i"
              	:label="postIncidentsOpt.name"
                color="main-color"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 Detalles
            v-text-field.pt-0(
              ref="postincident"
              :disabled = "!!postIncidents"
            	v-model="postIncidentsDetails"
              hide-details
            )
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Es éste un caso de desaparición colectiva? 
        v-row
          v-col.align-radios(d-flex xs=4 sm=3)
            v-radio-group(v-model="collectiveCase" row hide-details @change="clearDetails($event,'collectiveCase')")
              v-radio(
              	v-for="(collectiveCaseOpt, i) in directAnswers"
              	:key="`collectiveCaseOpt${i}`"
              	:value="i"
              	:label="collectiveCaseOpt.name"
                color="main-color"
                
              )
          v-col.side-label(d-flex flex xs=6 sm=8)
            label.custom-secondary.pr-3 ¿Con qué otra desaparición se relaciona?
            v-text-field.pt-0(
              ref="collectiveCase"
              :disabled = "!!collectiveCase"
            	v-model="collectiveCaseDetails"
              hide-details
            )

</template>

<script>
export default {
  name: "Details",
  data() {
    return {};
  },
  computed: {
    directAnswers() {
      return this.$store.state.directAnswers;
    },
    witnessesExists: {
      get() { 
	    	return this.directAnswers.findIndex(
          witnessesExistsOpt => witnessesExistsOpt.slug == this.$store.state.record.narrative.details.witnessesExists.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.details.witnessesExists = this.directAnswers[index];
      }
    },
    witnessesDetails: {
      get() {
    		return this.$store.state.record.narrative.details.witnessesDetails;
    	},
    	set(value) {
    		this.$store.state.record.narrative.details.witnessesDetails = value;
    	}
    },
    disappearInVehicle: {
      get() { 
	    	return this.directAnswers.findIndex(
          disappearInVehicleOpt => disappearInVehicleOpt.slug == this.$store.state.record.narrative.details.disappearInVehicle.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.details.disappearInVehicle = this.directAnswers[index];
      }
    },
    disappearVehicletDetails: {
      get() {
    		return this.$store.state.record.narrative.details.disappearVehicletDetails;
    	},
    	set(value) {
    		this.$store.state.record.narrative.details.disappearVehicletDetails = value;
    	}
    },
    postIncidents: {
      get() { 
        return this.directAnswers.findIndex(
          postIncidentsOpt => postIncidentsOpt.slug == this.$store.state.record.narrative.details.postIncidents.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.details.postIncidents = this.directAnswers[index];
      }
    },
    postIncidentsDetails: {
      get() {
    		return this.$store.state.record.narrative.details.postIncidentsDetails;
    	},
    	set(value) {
    		this.$store.state.record.narrative.details.postIncidentsDetails = value;
    	}
    },
    collectiveCase: {
      get() { 
        return this.directAnswers.findIndex(
          collectiveCaseOpt => collectiveCaseOpt.slug == this.$store.state.record.narrative.details.collectiveCase.slug
        );
	    },
	    set(index) {
	    	this.$store.state.record.narrative.details.collectiveCase = this.directAnswers[index];
      }
    },
    collectiveCaseDetails: {
      get() {
    		return this.$store.state.record.narrative.details.collectiveCaseDetails;
    	},
    	set(value) {
    		this.$store.state.record.narrative.details.collectiveCaseDetails = value;
    	}
    }
  },
  methods: {
    clearDetails(value, reference) {
      if(!!value) {
        this.$refs[reference].internalValue = "";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.col {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.align-radios {
  align-self: flex-end;
}
</style>
